const withQuestionnaireSections = questionnaireSections => prevProjectOrTemplate => ({
    ...prevProjectOrTemplate,
    questionnaireSections,
});

export default withQuestionnaireSections;
